import { Button, Icon, Text, Row, Col, Div } from "atomize"
import { theme } from "./settings/config"
import { useContext } from "react"
import { modalContext } from "./providers/modal.provider"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Container from "./atoms/Container"
import { motion } from "framer-motion"
import { profileContext } from "./providers/profile.provider"
import PlayersList from "./PlayersList"
import { faBoxArchive, faPlus } from "@fortawesome/free-solid-svg-icons"
import TextInput from "./inputs/TextInput"
import { playersContext } from "./providers/players.provider"
import { schoolContext } from "./providers/school.provider"
import { isSmartphone } from "./atoms/SmartphoneView"
import { ABOVE_PHONE_NAV } from "./atoms/phoneBars"
import PhonePageTitle, { usePhoneSummary } from "./header/PhonePageTitle"

// "38 allievi · 4 archiviati"; senza archiviati solo i primi, e senza
// nessuno niente
export const playersSummary = (active, archived) => {
	if (!active && !archived) return null
	const parts = [active === 1 ? "1 allievo" : `${active} allievi`]
	if (archived) parts.push(archived === 1 ? "1 archiviato" : `${archived} archiviati`)
	return parts.join(" · ")
}

function PlayersContainer() {
	const Modal = useContext(modalContext)
	const { coach } = useContext(profileContext)
	const { getSelectedSchool, selectedSchool } = useContext(schoolContext)
	const {
		searchedPlayers,
		handleSearchedPlayerChange,
		showArchived,
		toggleShowArchived,
		activePlayers,
		archivedPlayers,
		isLoading,
		loadedSchool,
	} = useContext(playersContext)

	const title = showArchived ? "Archivio" : "Allievi"
	// nella pillola in cima: "38 allievi · 4 archiviati", appena ci sono
	// quelli del circolo scelto (arrivano tutti insieme, archiviati compresi:
	// nessuna lettura in più)
	usePhoneSummary(
		!isLoading && loadedSchool === selectedSchool
			? playersSummary(activePlayers.length, archivedPlayers.length)
			: undefined,
	)

	return (
		<>
			<Container>
				{/* sul telefono il titolo sta a sinistra, sulla riga della pillola
				    in cima; sul computer resta in mezzo */}
				{isSmartphone ? (
					<PhonePageTitle>{title}</PhonePageTitle>
				) : (
					<Text
						textSize="display1"
						textAlign="center"
						textWeight="bold"
						textColor={theme.colors.gunmetal}
						m={{ t: "1rem" }}>
						{title}
					</Text>
				)}
				<Div
					textAlign={isSmartphone ? "left" : "center"}
					m={{ b: "1rem" }}
					style={{ minHeight: "1.5rem" }}>
					{showArchived ? (
						<Text textColor={theme.colors.text_light}>Allievi archiviati</Text>
					) : (
						<Text
							textColor={theme.colors.primary}
							cursor="pointer"
							onClick={() => getSelectedSchool() && Modal.open("importPlayers")}>
							Importa da un foglio
						</Text>
					)}
				</Div>
				<PlayersList />
			</Container>

			<Div d="flex" justify="center">
				<motion.div
					style={
						isSmartphone
							? {
									position: "fixed",
									bottom: ABOVE_PHONE_NAV,
									transform: "translateX(-50%)",
									width: "calc(100% - 2rem)",
									zIndex: "1",
							  }
							: {
									position: "fixed",
									width: "25rem",
									bottom: "5rem",
									zIndex: "1",
							  }
					}
					initial={{ y: 20 }}
					animate={{ y: 0 }}
					exit={{ y: 20 }}>
					<Row bg={theme.colors.primary_light} rounded="20px" p="0.5rem">
						<Col size="2" style={{ padding: "0 0.25rem" }}>
							<motion.div whileTap={{ scale: 0.9 }}>
								<Button
									w="100%"
									h="3.5rem"
									bg={showArchived ? theme.colors.gunmetal_fill : theme.colors.surface}
									textSize="subheader"
									shadow={theme.shadows.accent}
									rounded={theme.rounded["20px"]}
									title={
										showArchived
											? "Torna agli allievi attivi"
											: "Mostra gli allievi archiviati"
									}
									onClick={toggleShowArchived}>
									<FontAwesomeIcon
										icon={faBoxArchive}
										color={
											showArchived
												? theme.colors.white
												: theme.colors.gunmetal
										}
									/>
								</Button>
							</motion.div>
						</Col>
						<Col size="8" style={{ padding: "0 0.25rem" }}>
							<TextInput
								value={searchedPlayers}
								handleChange={e => {
									handleSearchedPlayerChange(e)
									// come nel quaderno: i risultati partono dall'inizio dell'elenco
									window.scrollTo({ top: 0 })
								}}
								placeholder={"Cerca giocatore"}
								m="0"
								isValid={true}
							/>
						</Col>
						<Col size="2" style={{ padding: "0 0.25rem" }}>
							<motion.div whileTap={{ scale: 0.9 }}>
								<Button
									w="3.5rem"
									h="3.5rem"
									bg={theme.colors.primary}
									shadow={theme.shadows.accent}
									rounded={theme.rounded["20px"]}
									aria-label="Nuovo allievo"
									onClick={() => {
										getSelectedSchool() && Modal.open("newPlayer")
									}}>
									{getSelectedSchool() && coach ? (
										<FontAwesomeIcon icon={faPlus} size="xl" />
									) : (
										<Icon name="Loading" size="20px" color="white" />
									)}
								</Button>
							</motion.div>
						</Col>
					</Row>
				</motion.div>
			</Div>
		</>
	)
}

export default PlayersContainer
